export default {
  midi_channel: "Keyboard_Global_USB_1_Channel", // 0
  mpe_active: "Keyboard_Global_Channel_Rotation_Active", // 0
  mpe_member_channels: "Keyboard_Global_Polyphony_Number", // 1 - 15
  pressure_cc: "Keyboard_CC_00_Control_Number", // 1
  tilt_cc: "Keyboard_CC_01_Control_Number", // 0

  bend_range_tilt: ["Keyboard_Pitch_Bend_Max", "Keyboard_Pitch_Bend_Min"], // 69,58; use bend range table
  bend_range_pad: ["Keyboard_Global_USB_2_Channel", "Keyboard_Global_Key_Selection_Criteria"], // 127, 0; use bend range table

  pressure_sensitivity: "Keyboard_CC_00_Gain", // 100; range [60:254]
  tilt_sensitivity: "Globals_Tilt_Sensitivity", // 50; range [70:0]
  velocity_sensitivity: "Keyboard_Velocity_Gain", // 89; range [60:254]

  velocity_curve: "Keyboard_Velocity_Curve", // Logarithmic : 1
  pressure_disabled_return: "Keyboard_Global_Program_Change_A", // -1 : off
  tilt_disabled_return: "Keyboard_Global_Program_Change_B", // -1 : off
  on_thresh: "Globals_On_Thresh" // 15
}
